module.exports = __webpack_public_path__ + "img/goto.e657e00e.svg";